import React, { Component } from 'react';
import { states } from '../../../../services/common/optionsData';

export default class AddressBlock extends Component {
    handleChange = (e) => {
        const subFieldId = this.props.fieldDef.fieldId + '_' + e.target.name;
        this.props.onChange(subFieldId, e.target.value);
    };

    render() {
        const { fieldDef, formValues, disabled } = this.props;
        const prefix = fieldDef.fieldId + '_';

        return (
            <div className="row form-row">
                <div className="col-12 col-md-6">
                    <div className="form-group">
                        <label>Address 1</label>
                        <input
                            type="text"
                            name="address1"
                            value={formValues[prefix + 'address1'] || ''}
                            onChange={this.handleChange}
                            disabled={disabled}
                            className="form-control"
                        />
                    </div>
                </div>
                <div className="col-12 col-md-6">
                    <div className="form-group">
                        <label>Address 2</label>
                        <input
                            type="text"
                            name="address2"
                            value={formValues[prefix + 'address2'] || ''}
                            onChange={this.handleChange}
                            disabled={disabled}
                            className="form-control"
                        />
                    </div>
                </div>
                <div className="col-12 col-md-6">
                    <div className="form-group">
                        <label>City</label>
                        <input
                            type="text"
                            name="city"
                            value={formValues[prefix + 'city'] || ''}
                            onChange={this.handleChange}
                            disabled={disabled}
                            className="form-control"
                        />
                    </div>
                </div>
                <div className="col-12 col-md-6">
                    <div className="form-group">
                        <label>State</label>
                        <select
                            className="form-control select"
                            name="state"
                            value={formValues[prefix + 'state'] || ''}
                            onChange={this.handleChange}
                            disabled={disabled}
                        >
                            {states.map((state) => (
                                <option key={state.value} value={state.value}>
                                    {state.state}
                                </option>
                            ))}
                        </select>
                    </div>
                </div>
                <div className="col-12 col-md-6">
                    <div className="form-group">
                        <label>Zip Code</label>
                        <input
                            type="text"
                            name="zip"
                            value={formValues[prefix + 'zip'] || ''}
                            onChange={this.handleChange}
                            disabled={disabled}
                            className="form-control"
                        />
                    </div>
                </div>
                <div className="col-12 col-md-6">
                    <div className="form-group">
                        <label>Country</label>
                        <input
                            type="text"
                            name="country"
                            value={formValues[prefix + 'country'] || ''}
                            onChange={this.handleChange}
                            disabled={disabled}
                            className="form-control"
                        />
                    </div>
                </div>
            </div>
        );
    }
}
